import React from 'react';
import { BookOpen, Mail, Calendar, Copyright } from 'lucide-react';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-slate-900 dark:bg-black text-white py-12 px-4 sm:px-6 lg:px-8 border-t border-slate-800">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="bg-gradient-to-br from-emerald-500 to-teal-600 p-2 rounded-xl shadow-lg">
                <BookOpen className="h-6 w-6 text-white" />
              </div>
              <span className="text-2xl font-bold bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">
                Bank Sampah Digital
              </span>
            </div>
            <p className="text-slate-400 leading-relaxed mb-4 max-w-md">
              Aplikasi Bank Sampah Digital merupakan platform terintegrasi yang dirancang untuk mengelola proses pengumpulan sampah, transaksi saldo, dan distribusi dana secara transparan dan efisien.
            </p>
            <div className="flex items-center space-x-2 text-slate-400">
              <Calendar className="h-4 w-4" />
              <span className="text-sm">Dikembangkan tahun {currentYear}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Navigasi Cepat</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  Beranda
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('overview')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  Overview
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('roles')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  Dokumentasi Fitur
                </button>
              </li>
              <li>
                <button
                  onClick={() => document.getElementById('workflow')?.scrollIntoView({ behavior: 'smooth' })}
                  className="text-slate-400 hover:text-emerald-400 transition-colors"
                >
                  Alur Proses
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4 text-white">Informasi Kontak</h3>
            <div className="space-y-3">
              <div className="flex items-center space-x-3 text-slate-400">
                <Mail className="h-5 w-5 flex-shrink-0" />
                <span className="text-sm">info@banksampahdigital.id</span>
              </div>
              <div className="flex items-center space-x-3 text-slate-400">
                <BookOpen className="h-5 w-5 flex-shrink-0" />
                <span className="text-sm">Dokumentasi Resmi Sistem</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <div className="flex items-center space-x-2 text-slate-400">
              <Copyright className="h-4 w-4" />
              <span className="text-sm">
                {currentYear} Bank Sampah Digital. Hak Cipta Dilindungi.
              </span>
            </div>
            <div className="text-sm text-slate-400">
              Platform Pengelolaan Sampah & Keuangan Berkelanjutan
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;